<template>
  <div>
    <h5
      class="title is-5"
      :class="[
        isCollapsed && collapsible ? 'mb-0' : '',
        collapsible ? 'title--collapsible-title' : ''
      ]"
      @click="collapsible ? (isCollapsed = !isCollapsed) : null"
    >
      <i
        v-if="collapsible"
        class="fa collapse-icon"
        :class="isCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"
      ></i>
      {{ title }}
    </h5>
    <div v-show="!collapsible || !isCollapsed">
      <template v-for="(value, key) in amenitiesList" v-bind:key="key">
        <div v-if="value !== null" class="mb-5">
          <h6 class="title is-6 mb-2">{{ $t("expedia." + key) }}</h6>
          <br />
          <span v-safe-html="cleanValue(value)"></span>
        </div>
      </template>
      <div class="amenity-grid">
        <div
          v-for="(a, index) in cleanedFlatAmenities"
          :key="index"
          class="is-flex is-align-items-center mb-1"
        >
          <span v-if="icons" class="amenity-icon-col">
            <i v-if="a.icon" :class="a.icon"></i>
          </span>
          <span>{{ a.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterHelper from "@/helpers/filters.helper.js";
export default {
  components: {},
  name: "AmenitiesList",
  props: {
    amenitiesList: Object,
    flatAmenitiesList: Array,
    title: String,
    collapsible: {
      type: Boolean,
      default: true
    },
    icons: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  data: function () {
    return {
      isCollapsed: true,
      primeAmenities: []
    };
  },
  created() {
    this.primeAmenities = FilterHelper.getPrimeAmenities().filter(
      (a) => a.icon
    );
  },
  methods: {
    cleanValue(value) {
      if (value === null) {
        return this.$t("expedia.not_available");
      }

      if (typeof value === "object") {
        if (Array.isArray(value)) {
          return value.join(", ");
        } else {
          let result = "";
          for (const key in value) {
            if (value[key] !== null) {
              if (Array.isArray(value[key])) {
                result += `<h6 class="title is-6 mb-2">${this.$t("expedia." + key)}</h6><ul><li>${value[key].join("</li><li>")}</li></ul>`;
              } else {
                result += `<h6 class="title is-6 mb-2">${this.$t("expedia." + key)}</h6><p>${value[key]}</p>`;
              }
            }
          }
          return result || this.$t("expedia.not_available");
        }
      }

      return value;
    },
    decodeHtmlEntities(text) {
      const txt = document.createElement("textarea");
      txt.innerHTML = text.replace(/<[^>]*>/g, "");
      return txt.value;
    }
  },
  computed: {
    cleanedAmenities() {
      return this.data;
    },
    cleanedFlatAmenities() {
      return (this.flatAmenitiesList || []).map((key) => {
        const translationKey = "expedia." + key;
        const prime = this.primeAmenities.find((a) => a.name === key);
        return {
          label: this.$te(translationKey) ? this.$t(translationKey) : key,
          icon: prime?.icon || null
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.amenity-grid {
  columns: 2;
  column-gap: 1.5rem;

  > div {
    break-inside: avoid;
  }
}

.amenity-icon-col {
  display: inline-flex;
  justify-content: center;
  width: 1.5rem;
  flex-shrink: 0;
  margin-right: 0.5rem;
}
</style>
